import type { FC } from 'react';
import { Suspense } from 'react';
import { Accordion, AccordionSummary, Stack, AccordionDetails, Typography, Skeleton } from '@mui/material';
import { VyIcon } from '@vy/ui-design-system';
import { useToggle } from '../../../../../../../../../../../hooks/use-toggle';
import { PaddleInvoiceProductsAccordionContent } from './PaddleInvoiceProductsAccordionContent';

type PaddleInvoiceProductsAccordionProps = {
  invoiceId: string;
  isExported: boolean;
};

export const PaddleInvoiceProductsAccordion: FC<PaddleInvoiceProductsAccordionProps> = ({
  invoiceId,
  isExported,
}) => {
  const [expanded, toggleExpanded] = useToggle(true);

  return (
    <Accordion expanded={expanded} onChange={() => toggleExpanded()} sx={{ p: 0 }}>
      <AccordionSummary
        expandIcon={
          <VyIcon
            icon="ArrowDown"
            style={{
              color: '#323232',
            }}
          />
        }
        sx={{ p: 0, height: '34px', alignItems: 'center' }}
      >
        <Stack
          direction="row"
          sx={{
            alignItems: 'center',
            gap: 1,
          }}
        >
          <VyIcon icon="OverdueClockStatus" />
          <Typography
            sx={{
              fontSize: 16,
              fontWeight: 600,
              lineHeight: '24px',
            }}
          >
            Products
          </Typography>
        </Stack>
      </AccordionSummary>
      <AccordionDetails sx={{ p: 0 }}>
        <Suspense fallback={<Skeleton variant="rectangular" height={100} />}>
          <PaddleInvoiceProductsAccordionContent invoiceId={invoiceId} disabled={isExported} />
        </Suspense>
      </AccordionDetails>
    </Accordion>
  );
};
